import dateFormat from 'dateFormat';

class DateTimeService {
    static FormatDateTimeToMMDDYYYY(dateTimeObj) {
        return dateFormat(new Date(dateTimeObj), 'm/d/yyyy');
    }
}

export default DateTimeService;